import { EMessageFileTypes } from '../../types/messageFiles';

export const getMessageFileSendType = (
  imageMimeTypes: string[],
  type: string,
): EMessageFileTypes.ImageAsDocument | EMessageFileTypes.Document => {
  if (imageMimeTypes.includes(type)) {
    return EMessageFileTypes.ImageAsDocument;
  }

  return EMessageFileTypes.Document;
};
